import { AsyncPipe, KeyValuePipe, NgClass, NgIf, NgStyle } from '@angular/common';
import { NgModule } from '@angular/core';
import { CustomMediaComponent, UrlMediaPipe } from '@sdvor/shared/ui';
import { SdPhotoswipeService } from '@shared/services/photoswipe.service';
import { SdBannerContentComponent } from './banner-content.component';

@NgModule({
  declarations: [SdBannerContentComponent],
  imports: [NgIf, AsyncPipe, NgClass, NgStyle, KeyValuePipe, UrlMediaPipe, CustomMediaComponent],
  exports: [SdBannerContentComponent],
  providers: [SdPhotoswipeService],
})
export class SdBannerContentModule {}
